export default "/images/6c88e079e24fc5e86921f337a99fc74a.avif";